import { AddressEntity, RawAddress } from './Types';
import { BaseModel } from '../BaseModel/BaseModel';

export class AddressModel
    extends BaseModel<RawAddress, AddressEntity>
    implements AddressEntity
{
    address: string = '';
    architectProjectId: number | null = null;
    billOfMaterialsProjectId: number | null = null;
    createdAt: string = new Date().toISOString();
    deletedAt: string | null = null;
    fullAddress: string = '';
    id: number = 0;
    latitude?: string;
    longitude?: string;
    projectId: number = 0;
    updatedAt: string = new Date().toISOString();

    constructor(data?: RawAddress) {
        super();
        if (data) {
            this.initialize(data);
        }
    }

    initialize(data: RawAddress): void {
        this.address = data.address;
        this.architectProjectId = data.architect_project_id;
        this.billOfMaterialsProjectId = data.bill_of_materials_project_id;
        this.createdAt = data.created_at;
        this.deletedAt = data.deleted_at;
        this.fullAddress = data.full_address;
        this.id = data.id;
        this.latitude = data.latitude;
        this.longitude = data.longitude;
        this.projectId = data.project_id;
        this.updatedAt = data.updated_at;
    }

    parse(): RawAddress {
        return {
            address: this.address,
            architect_project_id: this.architectProjectId,
            bill_of_materials_project_id: this.billOfMaterialsProjectId,
            created_at: this.createdAt,
            deleted_at: this.deletedAt,
            full_address: this.fullAddress,
            id: this.id,
            latitude: this.latitude,
            longitude: this.longitude,
            project_id: this.projectId,
            updated_at: this.updatedAt,
        };
    }
}
